"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollStatusBar = _interopRequireDefault(require("./PollStatusBar"));

var _styles = require("./styles");

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _PollOptions = _interopRequireDefault(require("./PollOptions"));

function PollResult(props) {
  var poll = props.poll;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.pollResultStyles, 'poll-result')
  }, _react.default.createElement(_DarkText.default, {
    className: "poll-question",
    fontSize: 32
  }, poll.question), _react.default.createElement(_PollStatusBar.default, props), _react.default.createElement(_PollOptions.default, props));
}

var _default = PollResult;
exports.default = _default;